<template>
    <div class="container login-container">
        <div class="navigation-wrapper">
            <div class="row">
                <div class="col-12">
                    <img class="img img-logo" src="/_resources/themes/bellstores/javascript/loyalty-program/src/assets/images/logo-bell-buddy-rewards.png" alt="Bell Buddy Rewards Logo" />
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-12">
                <router-link to="/register" class="btn btn-primary btn-bellstores" replace>
                    New Members
                </router-link>
            </div>
        </div>
        <div class="row">
            <div class="col-12">
                <h1>Sign In</h1>

                <div v-for="error in errorMessages" v-bind:key="error">
                    <div class="alert alert-danger">
                        {{error}}
                    </div>
                </div>

                <form v-on:submit="onSubmit">
                    <div class="form-group">
                        <input type="email" class="form-control" aria-describedby="emailHelp" placeholder="Enter email" v-model="emailAddress">
                    </div>
                    <div class="form-group">
                        <input type="password" class="form-control" placeholder="Password" v-model="password">
                    </div>
                    <button type="submit" class="btn btn-primary btn-bellstores" :disabled="!isValid">Submit</button>
                </form>

                <br>

                <router-link to="/forgot_password" replace>
                    Forgot Password?
                </router-link>
            </div>
        </div>
    </div>
</template>

<script>
import APIResponseError from '@/models/responses/APIResponseError'
import APIRequestError from '@/models/responses/APIRequestError'

export default {
    name: 'Login',
    dependencies: ['apiService', 'storageService'],
    data () {
        return {
            emailAddress: '',
            password: '',
            errorMessages: []
        }
    },
    methods: {
        async onSubmit (e) {
            e.preventDefault()
            this.errorMessages = []
            console.log('submitting')
            if (!this.apiService.isAuthenticated()) {
                console.log('not authenticated')
                await this.apiService.auth()
            }

            const response = await this.apiService.loginMember(this.emailAddress, this.password)

            if (response instanceof APIResponseError || response instanceof APIRequestError) {
                this.errorMessages.push(response.message())
                return
            }

            this.errorMessages = []
            this.storageService.setByKey('member', response.toStore())
            this.storageService.setByKey('logged_in', true)
            this.$router.replace({ name: 'Home' })
        }
    },
    computed: {
        isValid () {
            return this.emailAddress !== '' && this.password !== ''
        }
    }
}
</script>

<style scoped lang="scss">
    .row {
        text-align: center;

        .img-logo {
            float: none;
        }

        h1 {
            margin-top: 30px;
            margin-bottom: 15px;
        }

        .btn {
            margin: 10px auto;
            width: 100%;
        }

        .login-container {
            max-width: 445px;
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/Login.vue